import styled from 'styled-components';
export const StyledDiv = styled.div`

`
export const StyledH1 = styled.h1`
    border-bottom: 1px solid black;
    font-size:20px;
    padding-bottom:10px;
    margin-bottom:25px;
`



// WEBPACK FOOTER //
// ./src/components/FormSection/styles.js